module.exports = __webpack_public_path__ + "fefdaa7a84e8137d86b108b94c8fe8ea.jpg";